module.exports = __webpack_public_path__ + "static/media/sendIcon2.9ae694f8.svg";